import { GoogleAdSlot } from '../../sharedComponents/types'
import GoogleAd from '../../sharedComponents/GoogleAd/GoogleAd'
import styled from 'styled-components'
import { useEffect, useState } from 'react'
import adPlacementCss from './AdPlacementCss'
import { useGoogleAds } from '../../contexts/providers/GoogleAdsProvider/GoogleAdsContext'

const StyledTimeLineBox = styled(GoogleAd)`
  margin: auto;
  ${adPlacementCss({ width: 300, height: 250, display: 'flex' })};
`
const TimeLineBox = ({ pos }: { pos: number }) => {
  const [slot, setSlot] = useState<GoogleAdSlot | null>(null)
  const { pathPlatform } = useGoogleAds()

  useEffect(() => {
    if (pathPlatform) {
      setSlot({
        id: `timeline-box-${pos}`,
        path: `/36476105/${pathPlatform}/timeline/box${pos}`,
        size: [[250, 250], [300, 250], 'fluid'],
      })
    }
  }, [pathPlatform, pos])

  if (!slot) {
    return null
  }

  return <StyledTimeLineBox slot={slot} />
}
export default TimeLineBox
